import React from "react";
import { useState, useEffect, useMemo } from "react";
import axios from "axios";
import ConsolidationGrid from "./consolidationGrid";
import Loading from "./loading";
import { FaFilePdf } from "react-icons/fa";
import FormGroup from "@mui/material/FormGroup";
import FormHelperText from "@mui/material/FormHelperText";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import ModalBtstrp from "react-bootstrap/Modal";
import Checkbox from "@mui/material/Checkbox";
import {
  FaFileExcel,
  FaPlusSquare,
  FaMinusSquare,
  FaSave,
  FaCog,
  FaChevronDown,
  FaInfoCircle,
} from "react-icons/fa";
import { blue, grey } from "@mui/material/colors";
import { alpha, styled } from "@mui/material/styles";
import { useSelector } from "react-redux";
import { selectTheme } from "../features/theme/themeSlice";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { formatDate } from "@telerik/kendo-intl";

import { Modal } from "antd";
import { Button } from "@progress/kendo-react-buttons";
import { Circles, ColorRing } from "react-loader-spinner";
import { MdFilterAltOff } from "react-icons/md";
import { Viewer } from "@grapecity/activereports-react";
import { Button as BtnAntd, Menu, Space, Dropdown } from "antd";

const ConsolidationRpt = () => {
  //const [frmDate, setfrmDate] = React.useState(date);

  var disb =
    localStorage.getItem("SelAcctId") == 0
      ? localStorage.getItem("pRltncd") == null ||
        localStorage.getItem("pRltncd") == undefined ||
        localStorage.getItem("pRltncd") == ""
        ? localStorage.getItem("pConsId") === "0"
          ? false
          : true
        : false
      : false;
  const [consolidationData, setConsolidationData] = useState([]);
  const [showall, setShowall] = useState(
    localStorage.getItem("pConsId") == "0" ? true : false
  );
  var tempToken = JSON.parse(localStorage.getItem("token"));
  const [session, setSession] = useState("");
  var date = new Date(localStorage.getItem("processingDate"));
  const [AcctConsolidationReportData, populateAcctConsolidationReportData] =
    useState([]);
  const [pdfResultData, setPdfResultData] = useState();

  const [asOfDt, setasOfDt] = React.useState(date);
  const [priceDt, setpriceDt] = React.useState(date);
  var minDate = new Date(localStorage.getItem("processingDate"));
  minDate.setMonth(minDate.getMonth() - 60);
  var maxDate = new Date(localStorage.getItem("processingDate"));
  const [loading, setLoading] = useState(true);
  const [isResponse, setIsResponse] = useState(false);
  const [isColumnSave, setIsColumnSave] = useState(false);
  const [triggerColSave, setTriggerColSave] = useState(0);
  const [triggerColapse, setTriggerColapse] = useState(0);
  const [triggerExpand, setTriggerExpand] = useState(0);
  const [expandedState, setExpandedState] = React.useState(true);
  const [triggerExport, setTriggerExport] = useState(0);
  const [effectivecDtInd, seteffectiveDtInd] = useState(true);
  const [clearing, setClearing] = useState(false);
  const [triggerClearfilter, setTriggerClearfilter] = useState(0);
  const handleClose = () => {
    setShow(false);
  };

  const viewerRef = React.useRef();

  const [show, setShow] = useState(false);
  const handleEffectiveDtInd = (e) => {
    seteffectiveDtInd(e.target.checked ? true : false);
  };
  const themes = useSelector(selectTheme);
  function setDate(val) {
    if (val == null) {
      setasOfDt(asOfDt);
    } else {
      setasOfDt(val);
    }
  }
  function setPrcDt(val) {
    if (val == null) {
      setpriceDt(priceDt);
    } else {
      setpriceDt(val);
    }
  }

  const excelExport = () => {
    setShow(true);
    openReport();
    // if (_export.current !== null) {
    //   _export.current.save(allData);
    // }
  };

  const refreshToken = async () => {
    let token = JSON.parse(localStorage.getItem("token"));
    let AccessToken = token.token;
    let RefreshToken = token.refreshToken;
    const postData = { AccessToken, RefreshToken };
    const config = {
      headers: {
        authorization: `Bearer ${token.token}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    await axios
      .post("/token/Refresh", postData)

      .then((response) => {
        tempToken = response.data;
        localStorage.setItem("token", JSON.stringify(response.data));

        GetconsolidationData();
      })
      .catch((error) => {
        if (error.code === "ERR_BAD_REQUEST") {
          setSession("Session Expired");
        }

        console.log("my error is " + error);
      });
  };

  const BlueSwitch = styled(Switch)(({ theme }) => ({
    "& .MuiSwitch-switchBase.Mui-checked": {
      color: blue[600],
      "&:hover": {
        backgroundColor: alpha(blue[600], theme.palette.action.hoverOpacity),
      },
    },
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
      backgroundColor: blue[600],
    },

    "&.MuiSwitch-root .MuiSwitch-switchBase": {
      color: showall
        ? localStorage.getItem("pConsId") == 0
          ? blue[300]
          : blue[600]
        : grey[300],
    },
  }));
  const handleTriggerColapse = (event) => {
    setTriggerColapse((triggerColapse) => triggerColapse + 1);
    setExpandedState(false);
  };

  //new
  const [DialogMsg, setDialogMsg] = useState("Test");
  const [visible, setVisible] = React.useState(false);
  const toggleDialog = () => {
    setVisible(!visible);
  };

  const formSubmit = (event) => {
    event?.preventDefault();
    if (asOfDt == null || priceDt == null) {
      setDialogMsg("Enter date in correct format mm/dd/yyyy here");
      setLoading(false);
      toggleDialog();

      setasOfDt(new Date(localStorage.getItem("processingDate")));
      setpriceDt(new Date(localStorage.getItem("processingDate")));
    } else {
      const validationRules = [
        {
          condition: asOfDt > maxDate,
          message: "As Of Date cannot exceed the Processing Date",
        },
        {
          condition: asOfDt < minDate,
          message:
            "As Of Date cannot be less than 5 years to the Processing Date",
        },
        {
          condition: priceDt > maxDate,
          message: "Price Date cannot be exceed to the Processing Date",
        },
        {
          condition: priceDt < minDate,
          message:
            "Price Date cannot be less than 5 years to the Processing Date",
        },
      ];

      const messages = validationRules
        .filter((rule) => rule.condition)
        .map((rule) => rule.message);

      if (messages.length > 0) {
        setDialogMsg(messages.join("\n"));
        toggleDialog();
        return;
      }

      setTriggerColSave(0);
      GetconsolidationData();
      setExpandedState(true);
    }
  };
  const handleTriggerExpand = (event) => {
    setTriggerExpand((triggerExpand) => triggerExpand + 1);
    setExpandedState(true);
  };
  const handleExcelExport = (event) => {
    setTriggerExport((triggerExport) => triggerExport + 1);
  };

  const bankName = process.env.REACT_APP_BANK;
  // const bankName = "Demo";

  console.log("bankName", bankName);

  async function loadReport() {
    // load report definition from the file

    const reportResponse = await fetch("Consolidation.rdlx-json");

    const report = await reportResponse.json();
    return report;
  }
  async function openReport() {
    const report = await loadReport();
    // debugger;
    // for(let i=0;i<reportData.t1.length;i++){
    //   reportData.t1[i].mdlWegh = parseNumber(formatNumber( reportData.t1[i].mdlWegh,"n2"));
    // }

    report.ReportSections[0].PageFooter.ReportItems[0].Value =
      bankName + ".png";

    console.log("JSON", AcctConsolidationReportData);

    // report.DataSources[0].ConnectionProperties.ConnectString =
    //   "jsondata=" + JSON.stringify(consolidationData.consolView);
    report.DataSources[0].ConnectionProperties.ConnectString =
      "jsondata=" + JSON.stringify(AcctConsolidationReportData);

    console.log("loadReport", consolidationData.consolView);
    let parameters = [
      {
        Name: "pConsName",
        Value: [
          localStorage.getItem("pConsName") == "" ||
          localStorage.getItem("pConsName") == null
            ? 0
            : localStorage.getItem("pConsName"),
        ],
      },
      {
        Name: "pAccName",
        Value: [
          localStorage.getItem("SelAcctNm") == "" ||
          localStorage.getItem("SelAcctNm") == null
            ? 0
            : localStorage.getItem("SelAcctNm"),
        ],
      },
      {
        Name: "pShow",
        Value: [
          localStorage.getItem("SelAcctId") == "0" ? 1 : 0,

          // localStorage.getItem("pConsId") == "0"
          //   ? 0
          //   : localStorage.getItem("SelAcctNm"),
        ],
      },
    ];

    /////////////////////
    // viewerRef.current.Viewer.open(report);
    viewerRef.current.Viewer.open(report, { ReportParams: parameters });
  }

  const getColumnStateDb = async () => {
    //Storing column settings in DB

    let token = JSON.parse(localStorage.getItem("token"));
    let UserId = JSON.parse(localStorage.getItem("userId"));
    let GridId = 36;

    const postData = { UserId, GridId };
    const config = {
      headers: {
        authorization: `Bearer ${token.token}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    await axios
      .post("/RTGetGridColumn/Index", postData, config)
      .then((response) => {
        // console.log('save in db');
        // console.log(response);
        const rowData = response.data;

        if (rowData !== "") {
          setIsColumnSave(true);
          localStorage.setItem("gridColumns", rowData);
        } else {
          setIsColumnSave(false);
        }
      })
      .catch((error) => {
        console.log("error in save db " + error);

        return error;
      });
  };
  const handleTriggerColSave = (event) => {
    setTriggerColSave((triggerColSave) => triggerColSave + 1);
  };
  const handlechangeCheckbox = (e) => {
    setShowall(e.target.checked);

    GetconsolidationData(e.target.checked);
    setTriggerColSave(0);
  };
  const handleclearfilter = (event) => {
    setTriggerClearfilter((triggerClearfilter) => triggerClearfilter + 1);
    console.log("clear filter", triggerColSave);
    setClearing(true);
    setTimeout(() => {
      setClearing(false);
    }, 1400);
  };
  const GetconsolidationData = async (showall) => {
    setLoading(true);
    let EffectiveDtInd = effectivecDtInd;
    console.log("GetconsolidationData here");
    let UserId = JSON.parse(localStorage.getItem("userId"));
    //let UserId = 1744;
    let lAcctId =
      localStorage.getItem("SelAcctId") == null
        ? 0
        : localStorage.getItem("SelAcctId");
    let AcctId = showall === true ? "0" : lAcctId;
    let AsofDt = formatDate(asOfDt, "MM/dd/yyyy");
    let PriceDt = priceDt === null ? "" : formatDate(priceDt, "MM/dd/yyyy");
    //let startDate = frmDate;
    //let endDate = toDate;
    let token = tempToken;
    let CnsldtnId = showall === true ? "0" : localStorage.getItem("pConsId");
    //let CnsldtnTypId = 14;
    let RltnshpCd =
      localStorage.getItem("pRltncd") == null ||
      localStorage.getItem("pRltncd") == undefined
        ? ""
        : localStorage.getItem("pRltncd");
    const postData = {
      UserId,
      CnsldtnId,
      AcctId,
      RltnshpCd,
      EffectiveDtInd,
      AsofDt,
      PriceDt,
    };
    const config = {
      headers: {
        authorization: `Bearer ${token.token}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    await axios
      .post("/AdvGetConsolView", postData, config)
      .then((response) => {
        setLoading(false);
        console.log("Relationship Data", response.data);
        populateAcctConsolidationReportData(response.data.consolView);

        // for(var i=0;i<response.data.consolView.length;i++){
        //
        //   response.data.consolView[i].totalCash=response.data.consolView[i].totalCash+response.data.consolView[i].p3CashBlncAmt
        // }
        setConsolidationData(response.data);
        setIsResponse(true);
        getColumnStateDb();
        setExpandedState(true);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          refreshToken();
        }
      });
  };
  let userId = JSON.parse(localStorage.getItem("userId")); // data.Email;

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        //let data = location.state;

        let userId = JSON.parse(localStorage.getItem("userId")); // data.Email;

        //setEmail(email);
        GetconsolidationData();
        getColumnStateDb();

        //  console.log(data);
      } catch (error) {
        console.error(error.message);
      }
    };
    fetchData();
  }, [userId]);

  // const signOut = () => {

  //     navigate("/");
  //     let token = JSON.parse(localStorage.getItem('token'));
  //     const postData = {};
  //     const config = {
  //       headers: {
  //         'authorization': `Bearer ${token.token}`,
  //         'Accept': 'application/json',
  //         'Content-Type': 'application/json'
  //       }

  //     };
  //     axios.post('/token/revoke',
  //       postData,
  //       config
  //     )
  //       .then((response) => {
  //         //
  //         // localStorage.setItem('token', '');
  //         //console.log(response);
  //         // navigate("/");

  //         // if (response.statusText === '') {

  //         // }

  //       })
  //       .catch((error) => {
  //         //
  //         console.log("my error is " + error);
  //       })

  //     // let tokenNew={token:''};
  //     // localStorage.setItem('token',JSON.stringify(tokenNew));
  //     // localStorage.setItem("AcctSelected",null);
  //     localStorage.removeItem('token');
  //     localStorage.clear();
  //     //firebaseApp.auth.signOut();

  //   }

  if (loading) {
    return (
      <div className="container-fluid">
        <div className="table-responsive">
          <table className="table table-borderless">
            <tbody>
              <tr className="align-middle">
                {/* Collapse/Expand Button */}
                <td className="align-middle text-center">
                  {expandedState ? (
                    <button
                      className="btn btn-outline-secondary btn-sm"
                      onClick={handleTriggerColapse}
                    >
                      <FaMinusSquare /> Collapse
                    </button>
                  ) : (
                    <button
                      className="btn btn-outline-secondary btn-sm"
                      onClick={handleTriggerExpand}
                    >
                      <FaPlusSquare /> Expand
                    </button>
                  )}
                </td>

                {/* Table Options Dropdown */}
                <td className="align-middle text-center">
                  <Dropdown
                    overlay={
                      <Menu>
                        <Menu.Item onClick={handleTriggerColSave}>
                          <FaSave /> Save Columns
                        </Menu.Item>
                        <Menu.Item onClick={handleclearfilter}>
                          <MdFilterAltOff /> Clear Filters
                        </Menu.Item>
                        <Menu.Item onClick={handleExcelExport}>
                          <FaFileExcel /> Export to Excel
                        </Menu.Item>
                        <Menu.Item onClick={excelExport}>
                          <FaFilePdf /> Export to PDF
                        </Menu.Item>
                      </Menu>
                    }
                  >
                    <button className="btn btn-outline-secondary btn-sm">
                      <FaCog /> Table Options <FaChevronDown />
                    </button>
                  </Dropdown>
                </td>

                {/* As Of Date Input */}
                <td className="align-middle">
                  <div className="d-flex align-items-center">
                    <span className="me-2">As Of Date:</span>
                    <DatePicker
                      className="form-control form-control-sm"
                      size="small"
                      width={150}
                      value={asOfDt}
                      max={maxDate}
                      min={minDate}
                      onChange={(e) => {
                        setDate(e.value);
                        setPrcDt(e.value);
                      }}
                      format="MM/dd/yyyy"
                    />
                  </div>
                </td>

                {/* Price Date Input */}
                <td className="align-middle">
                  <div className="d-flex align-items-center">
                    <span className="me-2">Price Date:</span>
                    <DatePicker
                      className="form-control form-control-sm"
                      size="small"
                      width={150}
                      value={priceDt}
                      max={maxDate}
                      min={minDate}
                      onChange={(e) => setPrcDt(e.value)}
                      format="MM/dd/yyyy"
                    />
                  </div>
                </td>

                {/* Effective Date Indicator (changed to EDF with Tooltip) */}
                <td className="align-middle">
                  <FormControlLabel
                    control={
                      <Checkbox
                        sx={{
                          color: "#0398fc",
                          "&.Mui-checked": {
                            color: "#0398fc",
                          },
                        }}
                        checked={effectivecDtInd}
                        onChange={handleEffectiveDtInd}
                      />
                    }
                    label={
                      <span
                        style={{
                          color: themes === "dark" ? "white" : "#454545",
                        }}
                      >
                        Eff.Date
                        <span
                          className="ms-1"
                          data-bs-toggle="tooltip"
                          title="Effective Date Indicator"
                          style={{
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                        >
                          <FaInfoCircle />
                        </span>
                      </span>
                    }
                  />
                </td>

                {/* Submit Button */}
                <td className="align-middle">
                  <button
                    className="btn btn-primary btn-sm"
                    type="submit"
                    onClick={formSubmit}
                  >
                    Submit
                  </button>
                </td>

                {/* Show All Switch */}
                <td className="align-middle">
                  <FormGroup>
                    <FormControlLabel
                      control={<BlueSwitch />}
                      checked={showall}
                      onChange={handlechangeCheckbox}
                      disabled={localStorage.getItem("pConsId") == 0}
                      label="Show All"
                      style={{ color: themes === "dark" ? "white" : "black" }}
                    />
                  </FormGroup>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div>
          <div className="">
            <Loading />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="">
      <div className="container-fluid">
        <ModalBtstrp
          style={{ zIndex: 1000000 }}
          show={show}
          onHide={handleClose}
          fullscreen={true}
          size="xl"
        >
          <ModalBtstrp.Body>
            <div id="viewer-host">
              <Viewer ref={viewerRef} />
            </div>
          </ModalBtstrp.Body>
          <ModalBtstrp.Footer>
            <button className="btn btn-primary  btn-sm" onClick={handleClose}>
              Close
            </button>
          </ModalBtstrp.Footer>
        </ModalBtstrp>
        <Modal
          title="Validation"
          open={visible}
          onOk={(e) => {
            setVisible(false);
          }}
          onCancel={(e) => {
            setVisible(false);
          }}
          footer={[
            <Button
              key="Ok"
              onClick={(e) => {
                setVisible(false);
              }}
            >
              Ok
            </Button>,
          ]}
        >
          <div style={{ whiteSpace: "pre-line" }}>{DialogMsg}</div>
        </Modal>
        <table className="table table-borderless">
          <tbody>
            <tr>
              {/* Collapse/Expand Button */}
              <td className="align-middle text-center">
                {expandedState ? (
                  <button
                    className="btn btn-outline-secondary btn-sm"
                    onClick={handleTriggerColapse}
                  >
                    <FaMinusSquare /> Collapse
                  </button>
                ) : (
                  <button
                    className="btn btn-outline-secondary btn-sm"
                    onClick={handleTriggerExpand}
                  >
                    <FaPlusSquare /> Expand
                  </button>
                )}
              </td>

              {/* Dropdown for Table Options */}
              <td className="align-middle text-center">
                <Dropdown
                  overlay={
                    <Menu>
                      <Menu.Item onClick={handleTriggerColSave}>
                        <FaSave /> Save Columns
                      </Menu.Item>
                      <Menu.Item onClick={handleclearfilter}>
                        <MdFilterAltOff /> Clear Filters
                      </Menu.Item>
                      <Menu.Item onClick={handleExcelExport}>
                        <FaFileExcel /> Export to Excel
                      </Menu.Item>
                      <Menu.Item onClick={excelExport}>
                        <FaFilePdf /> Export to PDF
                      </Menu.Item>
                    </Menu>
                  }
                >
                  <button className="btn btn-outline-secondary btn-sm mx-2">
                    <FaCog /> Table Options <FaChevronDown />
                  </button>
                </Dropdown>
              </td>

              {/* Conditional Form Section (As Of Date, Price Date, Effective Date Indicator) */}
              {!showall &&
              localStorage.getItem("pConsId") !== "0" &&
              localStorage.getItem("SelAcctId") == 0 ? (
                <>
                  {/* As Of Date */}
                  <td className="align-middle">
                    <div className="d-flex align-items-center">
                      <span
                        className="me-2"
                        style={{
                          color: themes === "dark" ? "white" : "#454545",
                        }}
                      >
                        As Of Date:
                      </span>
                      <DatePicker
                        className="form-control form-control-sm"
                        size="small"
                        width={150}
                        value={asOfDt}
                        max={maxDate}
                        min={minDate}
                        valid={
                          asOfDt >= minDate &&
                          asOfDt <= maxDate &&
                          asOfDt != null
                        }
                        onChange={(e) => {
                          setasOfDt(e.value);
                          setpriceDt(e.value || priceDt);
                        }}
                        validationMessage={
                          asOfDt == null
                            ? "Enter Valid Date"
                            : asOfDt < new Date("1/1/1000")
                            ? "Enter date in correct format (mm/dd/yyyy)"
                            : asOfDt > maxDate
                            ? "As Of Date cannot exceed the Processing Date"
                            : asOfDt < minDate
                            ? "As Of Date cannot be less than 5 years to the Processing Date"
                            : "Validation error"
                        }
                      />
                    </div>
                  </td>

                  {/* Price Date */}
                  <td className="align-middle">
                    <div className="d-flex align-items-center">
                      <span
                        className="me-2"
                        style={{
                          color: themes === "dark" ? "white" : "#454545",
                        }}
                      >
                        Price Date:
                      </span>
                      <DatePicker
                        className="form-control form-control-sm"
                        size="small"
                        width={150}
                        value={priceDt}
                        max={maxDate}
                        min={minDate}
                        valid={
                          priceDt >= minDate &&
                          priceDt <= maxDate &&
                          priceDt != null
                        }
                        onChange={(e) => setpriceDt(e.value)}
                        validationMessage={
                          priceDt == null
                            ? "Enter Valid Date"
                            : priceDt < new Date("1/1/1000")
                            ? "Enter date in correct format (mm/dd/yyyy)"
                            : priceDt > maxDate
                            ? "Price Date cannot exceed the Processing Date"
                            : priceDt < minDate
                            ? "Price Date cannot be less than 5 years to the Processing Date"
                            : "Validation error"
                        }
                      />
                    </div>
                  </td>

                  {/* Effective Date Indicator */}
                  <td className="align-middle">
                    <FormControlLabel
                      control={
                        <Checkbox
                          sx={{
                            color: "#0398fc",
                            "&.Mui-checked": { color: "#0398fc" },
                          }}
                          checked={effectivecDtInd}
                          onChange={handleEffectiveDtInd}
                        />
                      }
                      label={
                        <span
                          style={{
                            color: themes === "dark" ? "white" : "#454545",
                          }}
                        >
                          Eff.Date
                          <span
                            className="ms-1"
                            data-bs-toggle="tooltip"
                            title="Effective Date Indicator"
                            style={{
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                          >
                            <FaInfoCircle />
                          </span>
                        </span>
                      }
                    />
                  </td>

                  {/* Submit Button */}
                  <td className="align-middle">
                    <button
                      className="btn btn-primary btn-sm"
                      type="submit"
                      onClick={formSubmit}
                    >
                      Submit
                    </button>
                  </td>
                </>
              ) : null}

              {/* Show All Checkbox */}
              <td className="align-middle text-center">
                <FormGroup>
                  <FormControlLabel
                    control={<BlueSwitch />}
                    checked={showall}
                    onChange={handlechangeCheckbox}
                    disabled={localStorage.getItem("pConsId") == 0}
                    label="Show All"
                    style={{ color: themes === "dark" ? "white" : "black" }}
                  />
                </FormGroup>
              </td>
            </tr>
          </tbody>
        </table>

        <div>
          <div className="row d-flex  justify-content-between">
            {isResponse === true ? (
              <ConsolidationGrid
                data={consolidationData.consolView}
                triggerColapse={triggerColapse}
                triggerExpand={triggerExpand}
                triggerExport={triggerExport}
                triggerColSave={triggerColSave}
                triggerClearfilter={triggerClearfilter}
                flag={isColumnSave}
                AcctConsolidationReportData={AcctConsolidationReportData}
                populateAcctConsolidationReportData={
                  populateAcctConsolidationReportData
                }
              ></ConsolidationGrid>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default ConsolidationRpt;
